import { Component, Injector } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { RouterLink } from '@angular/router';

import { PricesService } from '@shared/services';
import { ViewBasePage } from '@shared/pages';
import { MyCurrencyPipe } from '@shared/pipes';
import type { TResponse, TPricingInfo } from '@shared/models';

@Component({
    'selector': 'app-prices',
    'templateUrl': './prices.page.html',
    'styleUrls': ['./prices.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule, MyCurrencyPipe ]
})
export class PricesPage extends ViewBasePage implements OnInit, OnDestroy {
    private pricesSubscription: any;
    public activePrices: TPricingInfo[] = [];
    public deactivePrices: TPricingInfo[] = [];

    constructor(private pricesService: PricesService, injector: Injector) {
        super(injector);
    }

    public override async ngOnInit() {
        try {
            const pricesObservable = this.pricesService.getObservable();
            this.pricesSubscription = pricesObservable.subscribe(async (allPrices: TPricingInfo[]) => {
                // console.log(`allPrices = ${JSON.stringify(allPrices)}`);
                this.activePrices = allPrices.filter((price) => (price.status === 'Active'));
                this.deactivePrices = allPrices.filter((price) => (price.status !== 'Active'));

                if (this.activePrices.length === 0) {
                    await this.uxHelperService.showAlert('WARNING', 'No active pricing schedule exists.');
                }
            });
        } catch (err) {
            const errorMessage = this.utilsService.extractError(err);
            await this.uxHelperService.showAlert('Error!', errorMessage);
        }
    }

    public override ngOnDestroy() {
        if (this.pricesSubscription) {
            this.pricesSubscription.unsubscribe();
        }
    }

    public async onDeactivatePrice(price: TPricingInfo): Promise<void> {
        price.status = 'Non-Active';
        await this.pricesService.update(price);

        // const question = 'Are you sure you want to Deactivate this price: ' + price.priceName + '';
        // this.uxHelperService.showConfirmationAlert('Confirm Deactivation', question, async (response) => {
        //     if (response.selection) {
        //         try {
        //             this.uxHelperService.showSpinner('Deactivating.');
        //             price.status = 'Non-Active';
        //             await this.pricesService.update(price)
        //             this.uxHelperService.hideSpinner();
        //             const msg = 'Success. ' + price.priceName + ' ' + 'has been deactivated!';
        //             await this.uxHelperService.showAlert('Important', msg); 
        //         }
        //         catch(err) {
        //             this.uxHelperService.hideSpinner();
        //             await this.uxHelperService.showAlert('Error!', err);
        //         };
        //     }
        // });
    }

    public async onConfirmActivatePrice(price: TPricingInfo): Promise<void> {
        price.status = 'Active';
        await this.pricesService.update(price);
    }

    public async onConfirmDeletePrice(price: TPricingInfo) {
        const question = 'Are you sure you want to delete: ' + price.priceName + '';

        const response = await this.uxHelperService.showAlert('Confirm Delete', question);
        if (response.okay) {
            try {
                this.uxHelperService.showSpinner('Deactivating.');
                price.status = 'Non-Active';
                await this.pricesService.delete(price.uid);
                this.uxHelperService.hideSpinner();
                const msg = 'Success. ' + price.priceName + ' ' + 'has been deleted!';
                await this.uxHelperService.showAlert('Important', msg);
            } catch (err) {
                this.uxHelperService.hideSpinner();
                const errorMessage = this.utilsService.extractError(err);
                await this.uxHelperService.showAlert('Error!', errorMessage);
            }
        }
    }

    public onAddPriceClick(): void {
        this.router.navigateByUrl('/price');
    }

    public onPriceClick(uid: string): void {
        this.router.navigateByUrl(`/price/${uid}`);
    }
}
